import Cry from "assets/MoodCry.png";
import Fall from "assets/MoodFall.png";
import Imagine from "assets/MoodImagine.png";
import Laugh from "assets/MoodLaugh.png";
import Scream from "assets/MoodScream.png";
import Think from "assets/MoodThink.png";

export const MOODS_TYPES = [
  {
    type: "cry",
    category: 8,
    cover: Cry,
  }, {
    type: "fall",
    category: 15,
    cover: Fall,
  }, {
    type: "laugh",
    category: 6,
    cover: Laugh,
  }, {
    type: "imagine",
    category: 2,
    cover: Imagine,
  }, {
    type: "scream",
    category: 16,
    cover: Scream,
  }, {
    type: "think",
    category: 7,
    cover: Think,
  },
];
